<template>
  <!-- eslint-disable -->
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="19" viewBox="0 0 14 19">
    <g fill="none" fill-rule="evenodd" transform="translate(-2 -1)">
      <polygon points="0 0 20 0 20 20 0 20"></polygon>
      <path
        :fill="fill"
        fill-rule="nonzero"
        d="M11.2416667,4.56666667 C12.1583333,4.56666667 12.9083333,3.81666667 12.9083333,2.9 C12.9083333,1.98333333 12.1583333,1.23333333 11.2416667,1.23333333 C10.325,1.23333333 9.575,1.98333333 9.575,2.9 C9.575,3.81666667 10.325,4.56666667 11.2416667,4.56666667 Z M8.24166667,16.15 L9.075,12.4833333 L10.825,14.15 L10.825,19.15 L12.4916667,19.15 L12.4916667,12.9 L10.7416667,11.2333333 L11.2416667,8.73333333 C12.325,9.98333333 13.9916667,10.8166667 15.825,10.8166667 L15.825,9.15 C14.2416667,9.15 12.9083333,8.31666667 12.2416667,7.15 L11.4083333,5.81666667 C11.075,5.31666667 10.575,4.98333333 9.99166667,4.98333333 C9.74166667,4.98333333 9.575,5.06666667 9.325,5.06666667 L4.99166667,6.9 L4.99166667,10.8166667 L6.65833333,10.8166667 L6.65833333,7.98333333 L8.15833333,7.4 L6.825,14.15 L2.74166667,13.3166667 L2.40833333,14.9833333 L8.24166667,16.15 Z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      default: '#94979B',
      type: String,
    },
  },
};
</script>
